module.exports = __webpack_public_path__ + "img/centrales.adfbbfca.jpg";